import { fetchConnectionStatus } from './fetch-connection-status';
import { updateConnectionStatus } from './update-connection-status';

export const actions = {
    fetchConnectionStatus,
    updateConnectionStatus,
} as const;

export type Actions = typeof actions;
